<template>
	<template v-for="item in  items">
		<template v-if="item.modale === 0">
			<Button as="a" :icon="item.icona" :aria-label="getTooltipLabel(item)"
							:title="getTooltipLabel(item)"
							:href="generateUrl(item.link , item.params , item.referer_params)" variant="text" rounded
							v-tooltip.bottom="getTooltipLabel(item)"/>
		</template>
		<template v-else>
			<Button v-for="item in items"
							as="a" :icon="item.icona" :aria-label="getTooltipLabel(item)"
							:title="getTooltipLabel(item)"
							variant="text" rounded @click="mostraContenuto(item.link)"
							v-tooltip.bottom="getTooltipLabel(item)"/>
		</template>
	</template>



	<Dialog
		v-model:visible="showModal"
		modal
		header="Titolo del Modale"
		:style="{ width: '25rem' }"
	>
		<p id="contenuto">gfgdfgdf</p>
		<Button
			label="Conferma"
			class="p-button-success"
			@click="confirmAction"
		/>
	</Dialog>

	<!--    <Button v-for="(item, key) in items"
							:key="key"
							as="a"
							:icon="item.icona"
							:aria-label="$root.trans[item.nome]"
							:href="generateUrl(item.link, item.params, item.referer_params)"
							variant="text"
							rounded
							@click="() => { showModal[key] = true; }" />

			<Dialog v-model:visible="showModal[key]" modal :header="$root.trans.aggiungi+' '+value[0]"
			:style="{ width: '25rem' }">

					<a type="button" class="p-button p-component p-button-secondary"
						 @click="showModal[key] = false">{{ $root.trans.annulla }}</a>
					<button @click="checkModale(key)" class="p-button p-component p-button-success">
							<span class="p-button-label">{{ $root.trans.aggiungi }}</span>
					</button>
			</Dialog>-->

</template>

<script>
import axios from "axios";
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';

export default {
	name: "MenuStrumenti",
	components: {
		Button,
		Dialog
	},
	props: [
		'current_route',
		'current_params',
    'datatable_id'
	],
	data() {
		return {
			items: [],
			contenuto: "",
			params: this.current_params,
			showModal: false
		};
	},
	created() {
		axios.post('/menu_strumenti', {'current_route': this.current_route, 'datatable_id': this.datatable_id})
			.then(response => {
				this.items = response.data;
				console.log(this.items)
			})
			.catch(error => {
				console.error("Errore nel caricamento del menu strumenti:", error);
			});
	},

	methods: {
		getTooltipLabel(item) {
			if (item?.tooltip) return item.tooltip;

			const translated = this.$root?.trans?.[item?.nome];
			if (translated) return translated;

			return (item?.nome || '')
				.replace(/[_-]+/g, ' ')
				.replace(/\s+/g, ' ')
				.trim();
		},
		generateUrl(action, params, referer_params) {
			console.log(this.params);
			if(action != null) {
				var vm = this;
				if (params != null) {
					if (Object.keys(this.params).length > 0) {
						var list_params = {};
						var ref_p = referer_params.split(',');
						var par = params.split(',');
						ref_p.forEach(function (rp, key) {
							if (rp.includes(Object.keys(vm.params))) {
								list_params[par[key]] = vm.params[referer_params];
							}
						});
						console.log(list_params);
						if (!action || typeof action !== 'string') return '#';

						try {
							return route(action, list_params);
						} catch (e) {
							console.warn(`Errore con route(${action}):`, e);
							return '#';
						}
						//return route(action, list_params);
					}
				} else {
					try {
						return route(action);
					} catch (e) {
						console.warn(`Errore con route(${action}):`, e);
						return '#';
					}
					//	return route(action);
				}
			}
			return '#';
		},
		mostraContenuto(url) {
			alert('ok');
			var vm = this;
			vm.showModal = true;
			vm.contenuto = 'Testo nuovo';
		}
	}
}
</script>
<style scoped>

</style>
